import React from 'react';
import { whale } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Marine life',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'marine-life',
  icon: {
    baseShape: whale,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'marineLifeMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Marine life',
      itemTitleFunction: (item) => (item && item.title) || 'Marine life',
    },
    creationOptions: {
      menuText: 'Marine life',
      newTitle: 'Marine life',
      titlePlaceholder: 'Title for this marker',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker can indicate a range of different marine life. Include
          information such as type of marine life that frequents the area, and
          whether it is a protected sanctuary.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Marine life',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
